import { Link } from "react-router-dom";
import { CheckCircle2, Ticket, Mail } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function CheckoutReturn() {
  return (
    <>
      <Header />
      <section className="min-h-screen pt-32 pb-24 max-w-3xl mx-auto px-6 lg:px-10" data-testid="checkout-return-page">
        <div className="text-center">
          <CheckCircle2 size={56} className="mx-auto text-primary" />
          <p className="overline mt-6">Achat enregistré</p>
          <h1 className="mt-3 text-4xl md:text-5xl font-black tracking-tighter">
            Merci pour votre achat<span className="text-primary">.</span>
          </h1>
          <p className="text-muted-foreground mt-5 max-w-xl mx-auto leading-relaxed">
            Votre commande a été traitée par Whop. Vous recevrez vos billets et la confirmation
            de paiement directement par e-mail dans quelques instants.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 gap-4">
          <div className="border border-white/10 bg-card rounded-sm p-6">
            <div className="flex items-center gap-2 text-primary">
              <Ticket size={16} />
              <p className="font-mono text-xs tracking-[0.25em] uppercase">Vos billets</p>
            </div>
            <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
              Vos e-tickets sont envoyés à l'adresse e-mail renseignée lors du paiement. Pensez
              à vérifier vos courriers indésirables si vous ne les recevez pas sous 15 minutes.
            </p>
          </div>
          <div className="border border-white/10 bg-card rounded-sm p-6">
            <div className="flex items-center gap-2 text-primary">
              <Mail size={16} />
              <p className="font-mono text-xs tracking-[0.25em] uppercase">Une question ?</p>
            </div>
            <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
              Notre support vous répond sous 24 heures. Indiquez votre numéro de commande Whop
              pour un traitement plus rapide.
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-wrap gap-3 justify-center">
          <Link
            to="/"
            className="border border-white/20 px-5 py-3 rounded-sm font-bold text-sm hover:bg-white hover:text-black transition"
            data-testid="back-home-btn"
          >
            Retour à l'accueil
          </Link>
          <Link
            to="/contact"
            className="bg-primary text-primary-foreground px-5 py-3 rounded-sm font-bold text-sm hover:brightness-110"
            data-testid="support-btn"
          >
            Contacter le support
          </Link>
        </div>
      </section>
      <Footer />
    </>
  );
}
